<template>
  <div>
    <div class="" v-if="abstract">
      <div v-if="$route.params.pageid && $route.params.pageid > 0">
        <entitegenerator :entities="entities" :values="abstract"
                         :system="{main: 'submission', action: 'create'}"
                         :error="validation.errors"
                         :language="language"
                         :models="{'theme_list':theme_list, 'countries':countryData(),'gender':gender}"
                         mode="formular"></entitegenerator>
      </div>
      <div class="row mt-4">
        <div class="col d-flex">
          <button type="button" class="btn btn-info mr-auto" v-if="!processing.dynamicdata"
                  v-on:click="saveAndNext(previousSite(getCurrentPages(abstract.setting_submission_id), $route.params.pageid))">
            <icon :icon="['fas', 'angle-left']" size="lg"/>
            {{ wording[0].buttons.back }}
          </button>
          <ProcessingButton class="mr-auto" v-if="processing.dynamicdata"></ProcessingButton>
          <button type="button" class="btn btn-success mx-auto" v-on:click="saveAndNext(false)"
                  v-if="!processing.dynamicdata">
            <icon :icon="['fal', 'save']" size="lg"/>&nbsp;{{ wording[0].buttons.save }}
          </button>
          <ProcessingButton class="mx-auto" v-if="processing.dynamicdata"></ProcessingButton>
          <button type="button" class="btn btn-info float-right ml-auto"
                  v-if="hasNextSite(getCurrentPages(abstract.setting_submission_id), $route.params.pageid) && !processing.dynamicdata"
                  v-on:click="saveAndNext(nextSite(getCurrentPages(abstract.setting_submission_id), $route.params.pageid))">
            {{ wording[0].buttons.save_and_next }}
            <icon :icon="['fas', 'angle-right']" size="lg"/>
          </button>
          <ProcessingButton class="ml-auto" v-if="processing.dynamicdata"></ProcessingButton>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalValidateWarning" data-backdrop="static" data-keyboard="false" tabindex="-1"
         aria-labelledby="modalValidateWarningLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalValidateWarningLabel">
              <Speaker :submission_id="abstract.setting_submission_id" area="modal"
                       textkey="validate_warning_title"></Speaker>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"  v-on:click="noSaveNext = null;">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <div class="row">
                <div class="col-2 d-flex">
                  <icon :icon="['fad', 'exclamation-circle']" class="fa-3x mx-auto my-auto"/>
                </div>
                <div class="col-8 d-flex">
                  <div class="row my-auto">
                    <div class="col d-flex">
                      <h5 class="my-auto">
                        <Speaker :submission_id="abstract.setting_submission_id" area="modal"
                                 textkey="validate_warning_body"></Speaker>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-dismiss="modal" v-on:click="noSaveNext = null;">
              {{ wording[0].buttons.cancel }}
            </button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="saveAndProceed(noSaveNext)">
              {{ wording[0].buttons.proceed }}
              <icon :icon="['fas', 'angle-right']" size="lg"/>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import entitegenerator from 'entite-generator';

const VueScrollTo = require('vue-scrollto');
export default {
  components: {
    entitegenerator
  },
  data() {
    return {
      noSaveNext: null,
      initial_abstract: {}
    };
  },
  computed: {
    ...mapState([
      'abstract', 'themes', 'theme_list', 'wording', 'processing', 'validation', 'settings', 'datahelper', "language", 'gender'
    ]),
    ...mapGetters([
      'getCurrentPages', 'getCurrentPageById'
    ]),
    entities: function () {
      return this.$store.getters.getCurrentPageById(Number(this.$route.params.pageid)).entity;
    },
  },
  methods:
      {
        ...mapActions(['PUT_ABSTRACT', 'VALIDATE_TARGET']),
        async saveAndNext(target) {
          this.noSaveNext = target;
          this.processing.dynamicdata = true;
          if ((this.settings.validatebeforesave && this.settings.validatebeforesave === true) ||
              (this.abstract.edited && this.abstract.edited === true)) {
            let isValid = false;
            let targetXHr = 'page/' + this.$route.params.pageid;
            let data = {template: {}, target: targetXHr};
            data.template = this.abstract;
            await this.VALIDATE_TARGET(data).then((result) => {
              isValid = true;
              let validation = {"is_checked": true, "status": true, "errors": {}};
              this.$store.commit('SET_VALIDATION', {validation: validation});
            }).catch((error) => {
              this.noSaveNext = null;
              isValid = false;
              let validation = {"is_checked": true, "status": false, "errors": error.response.data};
              this.$store.commit('SET_VALIDATION', {validation: validation});
              this.$noty.error(this.wording[0].notify.save_not_success);
              this.$noty.error(this.wording[0].notify.validation_error);
              this.processing.dynamicdata = false;
            });
            if (isValid === false) return;
            await this.saveAndProceed(target);
          } else if (this.settings.validateBeforeSaveAndWarn && this.settings.validateBeforeSaveAndWarn === true) {
            let isValid = false;
            let targetXHr = 'page/' + this.$route.params.pageid;
            let data = {template: {}, target: targetXHr};
            data.template = this.abstract;
            await this.VALIDATE_TARGET(data).then((result) => {
              isValid = true;
              let validation = {"is_checked": true, "status": true, "errors": {}};
              this.$store.commit('SET_VALIDATION', {validation: validation});
              this.processing.dynamicdata = false;
              this.next(target);
              this.PUT_ABSTRACT(this.$route.params.id).then((result) => {
                this.$noty.success(this.wording[0].notify.save_success);
              });
            }).catch((error) => {
              isValid = false;
              let validation = {"is_checked": true, "status": false, "errors": error.response.data};
              this.$store.commit('SET_VALIDATION', {validation: validation});
              this.processing.dynamicdata = false;
              $('#modalValidateWarning').modal('show');
            });
          } else {
            if (this.validation.is_checked && !this.validation.status) {
              let targetXHr = '';
              let data = {template: {}, target: targetXHr};
              data.template = this.abstract;
              await this.VALIDATE_TARGET(data).then((result) => {
                let validation = {"is_checked": true, "status": true, "errors": {}};
                this.$store.commit('SET_VALIDATION', {validation: validation});
              }).catch((error) => {
                let validation = {"is_checked": true, "status": false, "errors": error.response.data};
                this.$store.commit('SET_VALIDATION', {validation: validation});
              });
            }
            await this.saveAndProceed(target);
          }
        },
        async saveAndProceed(target) {
          await this.PUT_ABSTRACT(this.$route.params.id).then((result) => {
            this.$noty.success(this.wording[0].notify.save_success);
            this.processing.dynamicdata = false;
            if (target !== false) {
              this.next(target);
            }
          }).catch((error) => {
            this.$noty.error(this.wording[0].notify.save_not_success);
            this.processing.dynamicdata = false;
          });
        },
        next(target) {
          this.$router.push(target);
        },
        nextCancel() {
          this.noSaveNext = null;
        },
      },
  created() {
    this.$store.dispatch('GET_THEMES')
    VueScrollTo.scrollTo('#top', 100, {easing: 'ease-in'});
  }
  , beforeRouteLeave(to, from, next) {
    if (!this.noSaveNext) {
      this.noSaveNext = to;
      this.saveAndNext(to);
    } else {
      this.noSaveNext = null;
      next()
    }
  }
  , beforeRouteUpdate(to, from, next) {
    if (!this.noSaveNext) {
      this.noSaveNext = to.path;
      this.saveAndNext(to.path);
    } else {
      this.noSaveNext = null;
      VueScrollTo.scrollTo('#top', 100, {easing: 'ease-in'});
      next()
    }
  }
}
</script>

<style scoped>

</style>
